import type { AddressBook } from "../../repository/AddressBookRepository.ts";
import { formatAddress } from "../../utils/formatAddress.ts";
import { openExplorerInNewTab } from "../../utils/explorerHelper.ts";
import {ExternalLinkIcon} from "lucide-react";

const LoadingRolesTables = () => {
  return (
    <tbody>
      {Array.from({ length: 4 }, (_, index) => (
        <tr key={index}>
          <td>
            <div className="skeleton h-10 w-full" />
          </td>
          <td className="w-full">
            <div className="skeleton h-10 w-full" />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const RoleRow = ({
  roleName,
  address,
}: {
  roleName: string;
  address: string;
}) => {
  return (
    <tr>
      <td>{roleName}</td>
      <td>{formatAddress(address, true)}</td>
      <td>
        <button
          className="btn btn-sm"
          onClick={() => openExplorerInNewTab(address)}
        >
          <ExternalLinkIcon />
        </button>
      </td>
    </tr>
  );
};

const RolesTables = ({
  isLoading,
  addressBook,
}: {
  isLoading: boolean;
  addressBook: AddressBook;
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="table">
        <thead>
          <tr>
            <th>Role name</th>
            <th>Address</th>
            <th>Action</th>
          </tr>
        </thead>
        {isLoading ? (
          <LoadingRolesTables />
        ) : (
          <tbody>
            <RoleRow roleName={"Admin"} address={addressBook.roles.owner} />
            <RoleRow
              roleName={"Contrôleur"}
              address={addressBook.roles.controller}
            />
            <RoleRow
              roleName={"Collecteur de frais"}
              address={addressBook.roles.feeCollector}
            />
          </tbody>
        )}
      </table>
    </div>
  );
};

export default RolesTables;
